import styled, { css } from 'styled-components';

export const Container = styled.div`
   position: relative;
   display: flex;
   width: 310px;
   flex-direction: column;
   padding: 0.3rem;
   border-radius: 10px;
   box-shadow: 0 1px 1px #ccc;
   background-color: ${({ isUserSystem }) => isUserSystem ? ' #E7F8FF' : '#ffffff'};
   user-select: none;
   .skeleton--box{
      position:relative;
      display: flex;
      width: 300px;
      height: 60px;
      justify-content: space-between;
      align-items: center;
      border-radius: 10px;
      background-color: #e9ecef;
      .description--{
         display: flex;
         position: absolute;
         z-index: 9;
         width: 100%;
         height: 100%;
         padding: 0.5rem;
         gap: 0.5rem;
         align-items: center;
         .filename{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
         }
      }
   }
   .skeleton::before{
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 10px;
      content: "";
      height: 100%;
      width: 100%;
      background-color: #e9ecef;
      background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
      background-repeat: no-repeat;
      background-size: 450px 400px;
      animation: shimmer 2s linear infinite;
   }
   @keyframes shimmer {
      0%{
         background-position: -450px 0;
      }
      100%{
         background-position: 450px 0;
      }
   }
   .footer-styled{
      margin-top: .5rem;
      margin-left: .5rem;
      margin-right:5px;
      ${({ isUserSystem }) =>
      !isUserSystem &&
      css`
            position: absolute;
            bottom: 6px;
            right: 10px;
         `
   }
   }
`;
export const PreviewPDF = styled.div`
   position: relative;
   width: 300px;
   height: 170px;
   overflow: hidden;
   border-radius:10px; 
   margin-bottom: 0.5rem;
   object{
      pointer-events: none;
      user-select: none;
   }
   .linkExternal{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      cursor: pointer;
   }
   .error-{
      display: flex;
      height: 100%;
      width: 100%;
      justify-content: center;
      align-items: center;
   }
`;
export const LoadSpin = styled.div`
  border: 2px solid #9c9c9c; 
  border-top: 2px solid #0000; 
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
export const Content = styled.div`
   display: flex;
   flex-direction: column;
`;
export const InfoDocument = styled.div`
   display: flex;
   width: 100%;
   min-width: 300px;
   max-width: 300px;
   height: 60px;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
   gap: 0.5rem;
   padding: 0 .75rem;
   border-radius: 10px;
   background-color:#f6f6f6f6; 
   > div:nth-child(2){
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
   }
   > div:nth-child(3){
      display: flex;
      gap: 0.5rem;
      align-items: center;
      color: #9c9c9c;
      font-size: 1.2rem;
   }
   .Down{
      font-size: 1.2rem;
   }
`;
export const IconFile = styled.div`
   .pdf {
      .icon--file {
         color: #ff0000;
      }
   }
   .fsTS{
      font-size: .676rem;
   }
   > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      > span {
         position: absolute;
         bottom: .5rem;
         z-index: 999;
         font-size: .872rem;
         font-weight: 700;
         color: #ffffff;
         background: transparent;
      }
      .icon--file{
         color: #9c9c9c;
      }
   }
`;
export const Body = styled.div`
   display: flex;
   width: 100%;
   margin-top: .5rem;
   margin-left: .5rem;
`;
